import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import FilesIcon from 'img/settings/settings-documents@2x.png';

class CompanyFile extends DomainObject {
  id;
  name;
  order;

  file;
  companyFileFolderId;

  _relations = {
    file: AttachedDocument
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      order: observable,
      file: observable,
      companyFileFolderId: observable,
      icon: computed,
      key: computed
    });

    this.merge(other);
  }

  get icon() {
    return FilesIcon;
  }

  get key() {
    return `file-${this.id}`;
  }
}

export default CompanyFile;
